






















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import { DepartmentFieldError } from '@/models/department';

export default Vue.extend({
  name: 'DepartmentPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    label: {
      type: String,
      default: 'Departments'
    },

    externalErrorMessage: {
      type: [Array, Object] as PropType<string[] | DepartmentFieldError>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      departmentLoading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      departments: 'department/getDepartments'
    }),

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: any) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];

      if (!(this.externalErrorMessage instanceof DepartmentFieldError)) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    // fetch all departments
    this.departmentLoading = true;

    //only fetch departments in production
    this.fetchDepartments(true)
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => (this.departmentLoading = false));
  },

  methods: {
    ...mapActions({
      fetchDepartments: 'department/fetchDepartments'
    })
  }
});
